import {Injectable} from "@angular/core";
import axios from "axios";

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  googleMapPlatformApiKey: string = '';
  constructor() {
  }

  public async setConfigAsync(): Promise<void> {
    let config = (await axios.get<any>("/core/config/")).data;

    this.googleMapPlatformApiKey = config.googleMapPlatformApiKey;
  }
}
